import { useQuery } from "@tanstack/react-query";
import {
  getDuplicateAccounts,
  DuplicateAccountParams,
} from "../services/get-duplicate-accounts";

export function useDuplicateAccounts(params: DuplicateAccountParams) {
  return useQuery({
    queryKey: ["duplicate-accounts", params],
    queryFn: () => getDuplicateAccounts(params),
    staleTime: 1000 * 60 * 2,
    refetchOnWindowFocus: false,
  });
}
